module.exports = __webpack_public_path__ + "videos/top-block.220ad90.mp4";